export const formatInt = (value: number | string): string => {
  const num =
    typeof value === 'string' ? parseInt(value.replace(/,/g, '')) : value
  if (isNaN(num)) return ''
  return num.toLocaleString('en-US')
}
export const cleanInt = (value: string): string => {
  return value.replace(/[^\d]/g, '')
}
export const handleIntInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
  const input = e.target
  const raw = cleanInt(input.value)
  input.value = raw
}
export const handleIntInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
  const input = e.target
  const raw = cleanInt(input.value)
  if (raw) {
    input.value = formatInt(raw)
  }
}
